

























































import { Vue, Component, Prop } from 'vue-property-decorator';
import CandidateAssessment from '@/domain/selective-process/entity/assessment/assessment.entity';
import CopyClipboardService from '@/shared/utils/copy-clipboard.service';
import ExportCultureGradeButton from './components/export-culture-grade-button.component.vue';
import ExportSelectiveProcessDetailsButton from './components/export-selective-process-details-button.component.vue';
import ImportCandidateModal from './modal/import-candidate-modal.vue';

@Component({
  components: {
    ExportCultureGradeButton,
    ExportSelectiveProcessDetailsButton,
    ImportCandidateModal,
  },
})
export default class SelectiveProcessHeader extends Vue {
  @Prop({
    required: true,
  }) assessments!: CandidateAssessment[];

  @Prop({
    type: Boolean,
    default: false,
  }) loading!: boolean;

  openImportCandidateModal: boolean = false;

  copyLink(acronymLanguage: string) {
    CopyClipboardService
      .copyToClipboard(
        `${process.env.VUE_APP_REDIRECT_URL}survey?lang=${acronymLanguage}`,
      );
  }
}
